import React, { useState } from 'react';
import { useChat } from '../../context/ChatContext';
import { initializeChat } from '../../services/api';
import { LogIn, Phone, ArrowRight } from 'lucide-react';
import { Snackbar, Alert } from '@mui/material';

function PhoneInput({ onSubmit, onGuestClick }) {
  const [phone, setPhone] = useState('');
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [error, setError] = useState('');
  const { setMessages } = useChat();

  const handleSubmit = async (e) => {
    if (!phone.trim()) {
      return;
    };
    e.preventDefault();

    try {
      const response = await initializeChat(phone);
      setMessages(response.chatHistory.history);
      onSubmit(phone); // This will trigger the parent's authentication
    } catch (err) {
      setError(err?.message || 'An error occurred');
    }
  };

  const handleCloseError = () => {
    setError('');
  };

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setPhone(value);
    setIsPhoneValid(value.length >= 10);
  };

  return (
    <div className="min-h-screen text-white flex items-center justify-center" style={{ background: "radial-gradient(circle at center, #feff4b 15%,rgba(255, 253, 230, 0.9) 50%,rgba(255, 255, 255, 0.95) 70%" }}>
      <div className="w-full max-w-md p-8 rounded-2xl backdrop-blur-sm bg-[#FFFFFF] border border-[#EEEEEE] shadow-xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2 text-[#000]">EasyKey.ai</h1>
          <p className="text-[#000]">Your Key to Homeownership, Made Easy</p>
        </div>

        <div className="space-y-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="phone" className="block text-sm font-medium text-gray-900 mb-1">
                Phone Number
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <Phone className="w-5 h-5 text-gray-400" />
                </div>
                <input
                  type="tel"
                  id="phone"
                  value={phone}
                  onChange={handlePhoneNumberChange}
                  placeholder="Enter your phone number"
                  className="w-full pl-10 pr-4 py-3 bg-[#F5F5F5] border border-gray-300 rounded-md focus:outline-none focus:ring-1 text-[#000]"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={!isPhoneValid}
              className={`w-full py-3 rounded-md flex items-center justify-center gap-2 transition-all ${isPhoneValid
                ? 'bg-[#000] hover:bg-gray-800 text-white cursor-pointer'
                : 'bg-[#efefef] text-gray-500 cursor-not-allowed'
                }`}
            >
              <LogIn className="w-5 h-5" />
              Continue with Phone
            </button>
          </form>

          <div className="relative flex items-center">
            <div className="flex-grow border-t border-gray-700"></div>
            <span className="flex-shrink mx-4 text-gray-700">or</span>
            <div className="flex-grow border-t border-gray-700"></div>
          </div>

          <button
            onClick={onGuestClick}
            className="w-full cursor-pointer py-3 bg-[#000] hover:bg-gray-800 text-white rounded-md flex items-center justify-center gap-2 transition-all "
          >
            <ArrowRight className="w-5 h-5" />
            Continue as Guest
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-700">
          <p className="text-center text-sm text-gray-700">
            By continuing, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
      <Snackbar
        open={error !== ''}
        autoHideDuration={2000}
        onClose={handleCloseError}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default PhoneInput;